<mat-chip-grid
  #chipGrid
  [attr.aria-label]="'Enter_Article_Number_tr' | translate"
  [disabled]="disabled"
  (focusin)="onFocusIn()"
  (focusout)="onFocusOut()"
>
  @if (prefixIcon) {
    <mat-icon class="prefix-icon">{{ prefixIcon }}</mat-icon>
  }
  @for (articleNumber of articleNumbers; track articleNumber) {
    <mat-chip-row (removed)="removeArticleNumber(articleNumber)">
      {{ articleNumber }}
      <button type="button" matChipRemove [attr.aria-label]="'Remove_tr' | translate" [disabled]="disabled">
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip-row>
  }

  <input
    #input
    [attr.data-testid]="testId"
    [placeholder]="placeholder"
    [matChipInputFor]="chipGrid"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    [matAutocomplete]="auto"
    [disabled]="disabled"
    (matChipInputTokenEnd)="addArticleNumber($event)"
    (blur)="addPendingArticleNumber($event)"
    (paste)="handlePaste($event)"
  />
</mat-chip-grid>

<mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectSuggestion($event)">
  @for (suggestion of filteredSuggestions(); track suggestion) {
    <mat-option [value]="suggestion">{{ suggestion }}</mat-option>
  }
</mat-autocomplete>
